import React, { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import {
  type HSIconImage,
  type HSIconSeqFrame,
  type HSIconVideo,
  HSPosType,
} from '@types';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import { reAddEditingHotspot } from '../../actions';
import ManualControl from './ManualControl';
import CoordControl from './CoordControl';

const items: DropdownItem[] = [
  { id: HSPosType.normal, name: '手动调整' },
  { id: HSPosType.adv, name: '坐标对齐' },
];

type Icon = HSIconImage | HSIconSeqFrame | HSIconVideo;

function DetailTab() {
  const { hotspot } = useStore($editingHotspot)!;
  const icon = hotspot.icon as Icon;
  const [type, setType] = useState(icon.positionType === HSPosType.adv ? 1 : 0);

  useEffect(() => {
    if (icon.stick === 0) {
      setType(0);
    }
  }, [icon.stick]);

  const handleTypeChange = (typeId: HSPosType) => {
    if (typeId === HSPosType.normal) {
      $editingHotspotApi.update((draft) => {
        const iconData = draft.icon as Icon;
        iconData.positionType = HSPosType.normal;
      });
      reAddEditingHotspot();
    }
    setType(typeId);
  };
  return (
    <>
      {icon.stick === 1 && (
        <WidgetRow>
          <div className="mb-10">细节调整方式：</div>
          <Dropdown selected={type} items={items} onChange={handleTypeChange} />
        </WidgetRow>
      )}
      {type === HSPosType.normal && <ManualControl />}
      {type === HSPosType.adv && <CoordControl />}
    </>
  );
}

export default DetailTab;
